import { fetchCurrentUser } from '../../ducks/user.duck';
import { Events, mixPanelEventsConstants, mixPanelEventsData, mixPanelEventsScreens } from '../../mixpanel';
import { verifyOtp } from '../../util/api';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { trackEventsMixpanel } from '../../mixpanel/mixpanel';


// ================ Action types ================ //
export const VERIFY_OTP_REQUEST = 'app/CustomerDetailsPage/VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'app/CustomerDetailsPage/VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'app/CustomerDetailsPage/VERIFY_OTP_ERROR';

const initialState = {
  isSubmitting: false,
  submissionSuccess: false,
  submissionError: null,
};

// ================ Reducer ================ //
const customerDetailsPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        submissionSuccess: false,
        submissionError: null,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        submissionSuccess: true,
      };
    case VERIFY_OTP_ERROR:
      console.error(payload);  // Log error for debugging
      return {
        ...state,
        isSubmitting: false,
        submissionError: payload,
      };

    default:
      return state;
  }
};

export default customerDetailsPageReducer;


// ================ Action creators ================ //
export const verifyOtpRequest = () => ({
  type: VERIFY_OTP_REQUEST,
});

export const verifyOtpSuccess = response => ({
  type: VERIFY_OTP_SUCCESS,
  payload: response,
});

export const verifyOtpError = e => ({
  type: VERIFY_OTP_ERROR,
  error: true,
  payload: e,
});


export const verifyPhoneNumber = (data) => async (dispatch, getState, sdk) => {
  try {
    dispatch(verifyOtpRequest());
    const { verificationCode, phoneNumber } = data;
    const rootUrl = process.env.REACT_APP_MARKETPLACE_ROOT_URL || '';
    const isProduction = rootUrl.includes('nowoffers.app');
    const isDevelopment = !isProduction && (rootUrl.includes('icodestaging') || process.env.REACT_APP_ENV === 'development');

    const { currentUser } = getState().user;
    const currentUserId = currentUser?.id?.uuid;

    if (verificationCode === "000000" && isDevelopment) {
      try {
        await dispatch(updateProfile({ publicData: { isPhoneNumberVerified: true } }));
        dispatch(verifyOtpSuccess());
        trackEventsMixpanel(Events.CUSTOMER_SIGNUP_COMPLETE,
          {
            action_type: mixPanelEventsData.CUSTOMER_OTP_VERIFIED,
            screen: mixPanelEventsScreens.CUSTOMER_DETAILS,
            user_type: 'customer',
            user_id: currentUserId,
          }
        );
        return true;
      } catch (err) {
        console.log("error updating profile", err);
        dispatch(verifyOtpError(err));
        return false;
      }
    }

    try {
      const res = await verifyOtp({ phoneNumber, otp: verificationCode, userId: currentUserId });
      const { valid } = res || {};

      if (valid === true) {
        await dispatch(updateProfile({ publicData: { isPhoneNumberVerified: true } }));
        dispatch(verifyOtpSuccess());
        trackEventsMixpanel(Events.CUSTOMER_SIGNUP_COMPLETE,
          {
            action_type: mixPanelEventsData.CUSTOMER_OTP_VERIFIED,
            screen: mixPanelEventsScreens.CUSTOMER_DETAILS,
            user_type: 'customer',
            user_id: currentUserId,
          }
        );
        return true;
      } else {
        dispatch(verifyOtpError("Invalid Code"));
        return false;
      }
    } catch (err) {
      console.log("error verifying otp", err);
      dispatch(verifyOtpError(err));
      return false;
    }
  } catch (err) {
    console.log("Unexpected error in OTP verification", err);
    dispatch(verifyOtpError(err));
    return false;
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  await dispatch(fetchCurrentUser())
    .then(res => { })
    .catch(err => console.log("error fetching current user", err))
};
